import React from "react";
import { Navigate, Outlet } from "react-router";
import { useSelector } from "react-redux";
import { authenticatedUser, isAuthenticating } from "../../redux/slice";
import LoadingScreen from "../../../../shared/components/Loading";

export type Role = "admin" | "supervisor" | "manager" | "assistant";

export const SUPERVISOR_ROLES: Role[] = ["admin", "supervisor"];
export const MANAGER_ROLES: Role[] = ["admin", "supervisor", "manager"];
export const ANY_ROLE: Role[] = ["admin", "supervisor", "manager", "assistant"];

interface RequireRoleProps {
    roles: Role[];
}

const RequireRole = ({ roles }: RequireRoleProps) => {
    const user = useSelector(authenticatedUser);
    const authenticating = useSelector(isAuthenticating);

    if (authenticating) return <LoadingScreen />;

    if (!user?.role) return null;

    return roles.includes(user.role) ? <Outlet /> : <Navigate to="/not_found" replace />;
};

export default RequireRole;
